<script setup>
const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  page: {
    type: String,
    default: null,
    validator: (value) => !value || ['tracking_page', 'thank_you_page', 'track_order_form'].includes(value),
  },
})

const startupDisclaimer = useState('startup-disclaimer')

const isVisible = computed(() => {
  if (props.text?.trim()) {
    return true
  }

  if (!props.page) {
    return false
  }

  const disclaimer = startupDisclaimer.value
  return !!(disclaimer?.text?.trim() && disclaimer[props.page])
})

const displayText = computed(() => {
  if (props.text?.trim()) {
    return props.text
  }

  return startupDisclaimer.value?.text ?? ''
})
</script>

<template>
  <div v-if="isVisible" class="files-disclaimer">
    <span class="files-disclaimer__icon">ℹ</span>
    <div class="files-disclaimer__text" v-html="displayText"></div>
  </div>
</template>

<style scoped lang="scss">
.files-disclaimer {
  border-left: 3px solid #c8a84b;
  padding: 8px 12px;
  background: #fffdf5;

  &__icon {
    display: none;
  }

  &__text {
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    color: #666;
    font-style: italic;
  }
}
</style>
